module.exports = __webpack_public_path__ + "static/GminaOsiek-4cc0d4791de99c43659a5cb1a1b57d3d.svg";